import { faCloud, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { FC } from 'react'
import styled from 'styled-components'

import type { SupportContact } from '@/lib/apollo/query/get-applicant'

import { getOldestContact } from './utils'

const Container = styled.div`
  background: #107cad;
  color: white;
  padding: 10px;
  display: grid;
  grid-template-columns: min-content 1fr min-content;
  grid-gap: 10px;
`

const Link = styled.a`
  color: white;
  width: 100%;
  text-wrap: nowrap;

  svg {
    margin-left: 10px;
  }
`

interface Props {
  supportContacts: SupportContact[]
  applicantFirstName: string
}

const SupportContactBanner: FC<Props> = ({ supportContacts, applicantFirstName }) => {
  const oldestContact = getOldestContact(supportContacts)

  return (
    <Container>
      <>
        <div>
          <FontAwesomeIcon size="1x" icon={faCloud} />
        </div>
        <div>
          <strong>Salesforce:</strong> Goodlord has recieved a support ticket regarding{' '}
          {applicantFirstName}'s application.
        </div>
        <Link href={oldestContact.link} target="_blank">
          View Salesforce ticket
          <FontAwesomeIcon size="1x" icon={faArrowUpRightFromSquare} />
        </Link>
      </>
    </Container>
  )
}

export default SupportContactBanner
